import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWifi, faRotate, faCloudArrowUp } from '@fortawesome/free-solid-svg-icons';
import useOnlineStatus from '../offline/useOnlineStatus';
import './OfflineStatusBadge.scss';

export default function OfflineStatusBadge() {
    const { isOnline, syncing, pendingCount } = useOnlineStatus();

    if (isOnline && !syncing && pendingCount === 0) return null;

    if (!isOnline) {
        return (
            <span
                className="offline-badge offline-badge--offline"
                data-tooltip-id="tooltip"
                data-tooltip-content="Pas de connexion — les ventes sont enregistrées localement et seront synchronisées au retour du réseau"
            >
                <FontAwesomeIcon icon={faWifi} />
                Hors ligne
            </span>
        );
    }

    if (syncing) {
        return (
            <span className="offline-badge offline-badge--syncing">
                <FontAwesomeIcon icon={faRotate} className="offline-badge__spin" />
                Synchronisation…
            </span>
        );
    }

    return (
        <span
            className="offline-badge offline-badge--pending"
            data-tooltip-id="tooltip"
            data-tooltip-content="Ventes enregistrées hors-ligne en attente d'envoi"
        >
            <FontAwesomeIcon icon={faCloudArrowUp} />
            {pendingCount} en attente
        </span>
    );
}
